import { render, staticRenderFns } from "./Artlist.vue?vue&type=template&id=6980e4b9&scoped=true"
import script from "./Artlist.vue?vue&type=script&lang=js"
export * from "./Artlist.vue?vue&type=script&lang=js"
import style0 from "./Artlist.vue?vue&type=style&index=0&id=6980e4b9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980e4b9",
  null
  
)

export default component.exports